import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { BrandDropdown, DirectionsDropdown } from "CommonDropdowns";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // Local state for managing the value objects for react-select
  const [brandValue, setBrandValue] = useState(null);
  const [directionValue, setDirectionValue] = useState(null);

  // Effect to clear local dropdown values when the main filter state is cleared
  useEffect(() => {
    if (!extraFiltersState.values.brand_id) setBrandValue(null);
    if (!extraFiltersState.values.direction_id) setDirectionValue(null);
  }, [extraFiltersState.values]);

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
  };

  const handleSearch = () => {
    onFilter();
  };

  const handleBrandChange = (selected) => {
    setBrandValue(selected);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, brand_id: selected ? selected.value : null },
    }));
  };

  const handleDirectionChange = (selected) => {
    setDirectionValue(selected);
    setExtraFiltersState((prev) => ({
      ...prev,
      values: {
        ...prev.values,
        direction_id: selected ? selected.value : null,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, [name]: value },
    }));
  };

  return (
    <div className="filters-flex">
      <Form>
        <Row className="align-items-end g-3">
          <Col>
            <BrandDropdown
              selectedId={extraFiltersState.values.brand_id || ""}
              value={brandValue}
              setValue={setBrandValue}
              isMulti={false}
              onChange={handleBrandChange}
            />
          </Col>

          <Col>
            <Form.Group className="mb-3">
              <DirectionsDropdown
                selectedId={extraFiltersState.values.direction_id || ""}
                value={directionValue}
                setValue={setDirectionValue}
                isMulti={false}
                onChange={handleDirectionChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Queue Name</Form.Label>
              <Form.Control
                type="text"
                name="queue_name"
                placeholder="Type a queue name"
                className="input-field"
                onChange={handleChange}
                value={extraFiltersState.values.queue_name || ""}
              />
            </Form.Group>
          </Col>
          <Col className="d-flex gap-2 mb-3">
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100"
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
                className="me-2"
              />{" "}
              Search
            </button>
            <button
              type="button"
              onClick={handleClear}
              className="btn btn-secondary"
            >
              Clear
            </button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Filter;
